import styled from "styled-components";

export const Inner = styled.div``;
